export { default as VictoryScatter } from "./victory-scatter";


//////////////////
// WEBPACK FOOTER
// ./~/victory-scatter/es/index.js
// module id = ./node_modules/victory-scatter/es/index.js
// module chunks = 1